import { createSubjectAttributes, useFeatureFlag } from '@user-portal/experimentation';
import { useMemo } from 'react';

import { selectCurrentUser } from 'store/user/selectors';

import { PATHS } from 'constants/routerPaths';

import { useSelector } from 'hooks';

export type MainScreenVariant = 'control' | 'downloadScreen' | 'workoutPlans';

type MainScreenConfig = {
    view?: string;
};

const VIEW_TO_VARIANT: Record<string, MainScreenVariant> = {
    downloadScreen: 'downloadScreen',
    workoutPlans: 'workoutPlans',
};

const VARIANT_TO_PATH: Record<MainScreenVariant, string> = {
    control: PATHS.DOWNLOAD_APP,
    downloadScreen: PATHS.DOWNLOAD_APP,
    workoutPlans: PATHS.WORKOUT_PLAN,
};

export const useMainScreenExperiment = (): { redirectPath: string; isReady: boolean } => {
    const currentUser = useSelector(selectCurrentUser);

    const subjectAttributes = useMemo(
        () =>
            createSubjectAttributes(
                currentUser?.core_id?.toString() || 'anonymous',
                currentUser?.core_id?.toString() || 'anonymous',
                {
                    extras: { link_id: currentUser?.url_params?.['link-id'] || 'default' },
                }
            ),
        [currentUser?.core_id, currentUser?.url_params]
    );

    const { value, isReady } = useFeatureFlag<MainScreenConfig>({
        flagKey: 'mb-portal-workout-plans-targeting',
        type: 'json',
        defaultValue: { view: 'downloadScreen' },
        subjectAttributes,
    });

    const variant: MainScreenVariant = VIEW_TO_VARIANT[value?.view ?? ''] ?? 'downloadScreen';

    return { redirectPath: VARIANT_TO_PATH[variant], isReady };
};
